import React, { useState } from "react";
import Filter from "../../Common/Filter/FilterNew";
import SearchFilter from "../../Common/SearchFilterTab/SearchFilter";
import "../../Common/SearchFilterTab/SearchFilter.scss";
import "./BlogToolbar.scss";

type FilterOption = { id: number | string; name: string };

type BlogToolbarProps = {
  search: string;
  onSearchChange: (value: string) => void;
  category: string;
  stage: string;
  categories: FilterOption[];
  stages: FilterOption[];
  onApplyFilters: (filters: { category: string[]; stage: string[] }) => void;
  onClearFilters: () => void;
};

const BlogToolbar = ({
  search,
  onSearchChange,
  category,
  stage,
  categories,
  stages,
  onApplyFilters,
  onClearFilters,
}: BlogToolbarProps) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const toggleFilter = () => setIsFilterOpen((open) => !open);
  const closeFilter = () => setIsFilterOpen(false);

  const selectedCategory = category ? [category] : [];
  const selectedStage = stage ? [stage] : [];

  const handleApply = (filters: { category: string[]; stage: string[] }) => {
    onApplyFilters(filters);
    closeFilter();
  };

  const handleReset = () => {
    onClearFilters();
    closeFilter();
  };

  return (
    <div className="blog-toolbar-wrap">
      <div className="search-container blog-search-container">
        <SearchFilter
          isFilter={isFilterOpen}
          isSearch={false}
          setIsFilter={toggleFilter}
          setIsSearch={() => undefined}
          handleChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onSearchChange(e.target.value)
          }
          search={search}
          placeholder="Search articles"
        />

        <Filter
          stage={stages}
          category={categories}
          filter={handleApply}
          reset={handleReset}
          isVisible={isFilterOpen}
          closeModal={closeFilter}
          pending={false}
          singleSelect
          selectedStage={selectedStage}
          selectedCategory={selectedCategory}
        />
      </div>
    </div>
  );
};

export default BlogToolbar;
